import { ModifierMapping } from "./enums";
export class TimeDistanceCalculator {
    static ComputeDistanceFromTime(timeDays, kmPerDay) {
        return timeDays * kmPerDay;
    }
    static ComputeRangeModifier(details) {
        const loadModifier = ModifierMapping.GetLoadModifier(details.Load);
        const paceModifier = ModifierMapping.GetPaceModifier(details.Pace);
        const terrainModifier = ModifierMapping.GetTerrainModifier(details.Terrain);
        const weatherModifier = ModifierMapping.GetWeatherModifier(details.Weather);
        return loadModifier * paceModifier * terrainModifier * weatherModifier;
    }
    static ComputeTimeFromDistance(distanceKm, kmPerDay) {
        return distanceKm / kmPerDay;
    }
}
//# sourceMappingURL=timedistancecalculator.js.map